import type { PortfolioDividendData } from '@/features/portfolio/hooks/usePortfolioDividend';

const getScore = (dividendScore: number | null) => {
  return {
    value: 1,
    future: 2,
    past: 3,
    health: 4,
    dividend: dividendScore,
    sentence: 'sentence',
    total: 6,
  };
};

const getDividendForecastPeriodData = (payment = 10) => ({
  payment,
  dividendYield: 0.2,
  yieldOnCapitalInvested: 0.1,
  dividendPaymentsGrowthAnnual: 0.1,
});

export const portfolioDividend: PortfolioDividendData = {
  Portfolio: {
    id: 'pid-123',
    currencyISO: 'USD',
    isAnalysisRestricted: false,
    analysis: {
      estimatedDividendYield: 0.2,
      estimatedYearlyDividend: 10,
      estimatedYearlyDividendYieldOnCapitalInvested: 0.1,
      estimatedYearlyDividendPast1y: 40,
    },
    holdingsCount: 3,
    holdings: [
      {
        company: {
          name: 'name 1',
          tickerSymbol: 'ticker 1',
          score: getScore(5),
        },
        dividendForecast: {
          past1y: getDividendForecastPeriodData(10),
          next1y: getDividendForecastPeriodData(20),
          next2y: getDividendForecastPeriodData(30),
          next3y: getDividendForecastPeriodData(40),
        },
      },
      {
        company: { score: getScore(3) },
        dividendForecast: {
          past1y: getDividendForecastPeriodData(100),
          next1y: getDividendForecastPeriodData(200),
          next2y: getDividendForecastPeriodData(300),
          next3y: getDividendForecastPeriodData(400),
        },
      },
      {
        company: { score: getScore(4) },
        dividendForecast: {
          past1y: getDividendForecastPeriodData(1000),
          next1y: getDividendForecastPeriodData(2000),
          next2y: getDividendForecastPeriodData(3000),
          next3y: getDividendForecastPeriodData(4000),
        },
      },
    ],
  },
} as unknown as PortfolioDividendData;